import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { compose } from 'recompose';
import * as fileInputActions from 'components/FileInput/actions';

export default compose(
  connect(
    ({ fileInput }) => ({ fileInput }),
    dispatch =>
      bindActionCreators(
        {
          ...fileInputActions,
        },
        dispatch,
      ),
  ),
);
